import { useParams } from "react-router-dom"
import { Box, Grid } from '@mui/material'
import Loader from '../../../../../Loader'
import BillingPeriodHeader from '../Shared/BillingPeriodHeader'
import InvoiceDataTable from '../Shared/InvoiceDataTable'
import JumboStat from '../Shared/JumboStat'
import { useGetCurrentDetailsByPartnerListingIdQuery } from "../../../../../../redux/slices/billingSlice"

function CurrentMonth() {
    const { id: partnerListingId } = useParams()
    const {
        data: currentDetails,
        isError,
    } = useGetCurrentDetailsByPartnerListingIdQuery(partnerListingId)

    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    if (!currentDetails) {
        return isError ? <InvoiceDataTable invoiceItems={[]} /> : <Loader />
    }
    return (
        <>
            <BillingPeriodHeader firstDay={currentDetails.billingCycleStart} lastDay={currentDetails.billingCycleEnd} />
            <Grid container sx={{ marginBottom: '10px' }} columns={16} spacing={1}>
                <Grid item xs={'auto'}>
                    <Box sx={{ borderRight: '1px solid #C5C5C5', padding: '0px 15px 8px 0px', paddingTop: '0', paddingBottom: '0' }}>
                        Subscription ID #{currentDetails.subscriptionId}
                    </Box>
                </Grid>
                <Grid item xs={'auto'}>
                    <Box sx={{ padding: '0px 15px 8px 0px', paddingTop: '0', paddingBottom: '0' }}>
                        Payment Method: {currentDetails.paymentMethod}
                    </Box>
                </Grid>
            </Grid>
            <Grid container sx={{ marginBottom: '50px', textAlign: 'center' }} columnSpacing={10} rowSpacing={0}>
                <JumboStat name={'Total Orders'} value={currentDetails.totalOrders} />
                <JumboStat name={'Total Sales'} value={formatter.format(currentDetails.totalSales)} />
                <JumboStat name={'Total Commission'} value={formatter.format(currentDetails.totalCommission)} />
            </Grid>
            <InvoiceDataTable invoiceItems={currentDetails.items} />
        </>
    )
}

CurrentMonth.propTypes = {
}

export default CurrentMonth
